module.exports = __webpack_public_path__ + "static/super-admin-layout-list-467510993da81a5e3f0d417d6c899096.png";